import { LocalDate } from '@js-joda/core';
import { useDeepCompareEffect } from 'react-use';

import { DayOfWeek } from '@dreryk/egabinet-appointment-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { WeekdayPicker } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

const DAYS_OF_WEEK_FIELD_NAME = 'daysOfWeek';

type WeekdayPickerFieldProps = Pick<FormContextValues<WeekdayPickerFormBeanPart>, 'register' | 'setValue'> & {
   readonly date?: LocalDate;
};
type WeekdayPickerFormBeanPart = {
   [DAYS_OF_WEEK_FIELD_NAME]?: DayOfWeek[];
};

export const WeekdayPickerField = (props: WeekdayPickerFieldProps): JSX.Element => {
   const { date, setValue } = props;
   const currentDayOfWeekAsString = date?.dayOfWeek().toString() as DayOfWeek;

   useDeepCompareEffect(() => {
      setValue(DAYS_OF_WEEK_FIELD_NAME, [currentDayOfWeekAsString]);
   }, [date]);

   return (
      <WeekdayPicker
         controller={props.register(DAYS_OF_WEEK_FIELD_NAME)}
         label={appointmentsTranslationKeys.create.form.dayOfWeeks}
         readOnlyDays={[currentDayOfWeekAsString]}
      />
   );
};
